import { useState } from 'react';
import styles from './FilesUploaderFilesList.module.scss';
import { useTranslation } from 'react-i18next';
import { AttachmentDto } from 'api/common/models/AttachmentDto';
import { FaTimes, FaTrash } from 'react-icons/fa';
import { FiFileText } from 'react-icons/fi';
import Button from 'common/components/button/Button';
import Modal, { ModalBody, ModalHeader } from 'common/components/modal/Modal';

interface Props {
    files: AttachmentDto[];
    disabled?: boolean;
    onRemove: (file: AttachmentDto) => void;
    onDownload?: (file: AttachmentDto) => void;
}

const isImage = (file: AttachmentDto) => !!file.contentType?.startsWith('image/');

const FilesUploaderFilesList = ({ files, disabled, onRemove, onDownload }: Props) => {
    const { t } = useTranslation();
    const [previewFile, setPreviewFile] = useState<AttachmentDto | null>(null);

    const filteredFiles = files.filter(f => !f.remove);

    return (
        <div className={styles.container}>
            {filteredFiles.map((file, i) => (
                <div key={i} className={styles.fileContainer}>
                    {isImage(file) && file.url
                        ? <img
                            src={file.url}
                            alt={file.name}
                            className={styles.thumbnail}
                            onClick={() => setPreviewFile(file)}
                        />
                        : <FiFileText className={styles.fileIcon} />
                    }
                    {file.url && !file.tempFile && onDownload
                        ? <span className={styles.fileText} onClick={() => onDownload(file)}>{file.name}</span>
                        : <span className={`${styles.fileText} ${styles.fileTextPlain}`}>{file.name}</span>
                    }
                    {!disabled && <Button variant="none" size="small" className={styles.fileRemoveIcon} onClick={() => onRemove(file)}>
                        <FaTrash />
                    </Button>}
                </div>
            ))}
            {filteredFiles.length === 0 && (
                <div className={styles.noItemsContainer}>
                    {t('common.without_files')}
                </div>
            )}
            <Modal
                isOpen={!!previewFile}
                onRequestClose={() => setPreviewFile(null)}
                style={{ content: { maxWidth: '90vw', maxHeight: '90vh', padding: 0, overflow: 'hidden' } }}
            >
                <ModalHeader className={styles.previewHeader}>
                    <span className={styles.previewTitle}>{previewFile?.name}</span>
                    <Button variant="none" size="small" className={styles.previewCloseButton} onClick={() => setPreviewFile(null)}>
                        <FaTimes />
                    </Button>
                </ModalHeader>
                <ModalBody className={styles.previewBody}>
                    {previewFile && <img src={previewFile.url} alt={previewFile.name} className={styles.previewImage} />}
                </ModalBody>
            </Modal>
        </div>
    );
}

export default FilesUploaderFilesList;
